import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "verify-chip",
  props: ["name", "state"],
  computed: {
    ...mapGetters({
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    isApprove() {
      return this.state === "VERIFIED";
    },

    isPending() {
      return this.state === "PROCESSING";
    },

    isReject() {
      return !this.state || this.state === "REJECTED";
    }
  },

  methods: {
    ...mapActions({
      setIdentityModal: types.identity.actions.SET_MODAL,
      setMobileModal: types.mobile.actions.SET_MODAL,
      setPhoneModal: types.phone.actions.SET_MODAL,
      setEmailModal: types.email.actions.SET_MODAL
    }),
    openModal() {
      switch (this.name) {
        case this.$t(
          "accountPage.identityInformation.personalStatus.progress.steps.personalInfo"
        ):
          this.setIdentityModal(true);
          break;

        case "شماره موبایل":
          this.setMobileModal(true);
          break;

        case "شماره ثابت":
          this.setPhoneModal(true);
          break;

        case "ایمیل":
          this.setEmailModal(true);
          break;
      }
    }
  }
};
